export const HERO_BLACK_FRIDAY = {
  cta: {
    href: 'https://www.serasa.com.br/premium/checkout/PREMIUM_ANUAL?cupom=BLACKFRIDAY2022',
  },
  image: {
    source:
      'https://cdn.builder.io/api/v1/image/assets%2Fb212bb18f00a40869a6cd42f77cbeefc%2F20705017a91b428483a2bff0cd761228',
    width: 1000,
    height: 513,
  },
}
